import React, { useEffect, useState } from 'react';
import Hero from '../layout/Home/Hero';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Caregiver from '../layout/Home/Caregiver';
// import Test from '../layout/Home/Test';
import Laboratory from '../layout/Home/Laboratory';
import Icuservice from '../layout/Home/Icuservice';
import Specialties from '../layout/Home/Specialties'
import Medicine from '../layout/Home/Medicine';
import Whychoose from '../layout/Home/Whychoose';
import Work from '../layout/Home/Work';
import Testimonial from '../layout/Home/Testimonial';
import Review from '../layout/Home/Review';
import AppShowcase from '../layout/Home/AppShowcase';
import Blog from '../layout/Home/Blog';
import Midbanner from '../layout/Home/Midbanner';
import Faq from '../layout/Home/Faq';
import PartnerSlider from '../layout/Home/PartnerSlider';
import "./Responsive.css";
import Product from '../layout/Home/Product';
import { fetchAPI } from '../utils/api';

export default function Home() {
  const [homeData, setHomeData] = useState({
    banners: [],
    services: [],
    testimonials: [],
    partners: [],
    faqs: [],
    home_settings: {},
    home_trusted_healthcare_desc: ''
  });
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    fetchAPI('HomeController')
      .then(res => {
        if (res.status === 200 && res.result) {
          setHomeData(res.result);
          if (res.result.home_settings && res.result.home_settings.home_care_title) {
            document.title = res.result.home_settings.home_care_title;
          }
        }
      })
      .catch(err => {
        console.error('Error fetching homepage data:', err);
      });

    fetchAPI('blog')
      .then(res => {
        if (res.status === 200 && res.result) {
          setBlogs(res.result);
        }
      })
      .catch(err => {
        console.error('Error fetching blogs:', err);
      });
  }, []);

  return (
    <div>
      <Header/>
      <Hero banners={homeData.banners} />
      <Caregiver services={homeData.services} homeSettings={homeData.home_settings} />
      {/* <Test /> */}  
      <Product homeSettings={homeData.home_settings} />
     
      <Icuservice homeSettings={homeData.home_settings} />
      <Specialties homeSettings={homeData.home_settings} />
      {/* <Laboratory homeSettings={homeData.home_settings} /> */}
      {/* <Medicine /> */}
      <Whychoose homeSettings={homeData.home_settings} />
      <PartnerSlider partners={homeData.partners} />
      <Work homeSettings={homeData.home_settings} />
      <Testimonial testimonials={homeData.testimonials} />
      {/* <Review /> */}
      <AppShowcase homeSettings={homeData.home_settings} />
      <Blog blogs={blogs} />
      <Midbanner homeSettings={homeData.home_settings} />
      <Faq faqs={homeData.faqs} />
      <Footer trustedDesc={homeData.home_trusted_healthcare_desc} />
    </div>
  )
}
